import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=3faebb6f&scoped=true"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"
import style0 from "./ServicesPage.vue?vue&type=style&index=0&id=3faebb6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faebb6f",
  null
  
)

export default component.exports